module.exports = __webpack_public_path__ + "img/img_safety_phone_img3.1ab5ed94.png";